import VCheckbox from './VCheckbox'

export { VCheckbox }
export default VCheckbox
